var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZeelogicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0H80C91.0457 0 100 8.9543 100 20C100 31.0457 91.0457 40 80 40H20C8.9543 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_10_161)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 80C100 68.9543 91.0457 60 80 60H20C8.95431 60 0 68.9543 0 80C0 91.0457 8.95431 100 20 100H80C91.0457 100 100 91.0457 100 80Z",
    fill: "url(#paint1_linear_10_161)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1421 34.1421C101.953 26.3316 101.953 13.6684 94.1421 5.85786C90.2369 1.95266 85.1185 3.88065e-05 80.0002 0C80.0001 0 80.0001 0 80 0H53.0001C57.1422 0 61.0002 3.35786 61.0002 7.5C61.0002 9.49203 60.3208 11.3027 59.0701 12.6457L58.7254 12.9903C58.7219 12.9936 58.7185 12.9968 58.715 13H58.7157L56 15.7157L5.85786 65.8579C-1.95262 73.6684 -1.95262 86.3316 5.85786 94.1421C9.76311 98.0474 14.8816 100 20 100H47.0001C42.8579 100 39 96.6421 39 92.5C39 90.5069 39.6801 88.6953 40.9322 87.3521L41.2725 87.0117C41.2767 87.0078 41.2809 87.0039 41.2852 87H41.2843L94.1421 34.1421Z",
    fill: "url(#paint2_linear_10_161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_161",
    x1: 1.86451e-7,
    y1: 13,
    x2: 44.5,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0492F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_161",
    x1: 95.5,
    y1: 88.5,
    x2: 55.5,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0492F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0036CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_161",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103DF2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeelogicon);
export default __webpack_public_path__ + "static/media/zeelogicon.4e96fed9f05675e87b3b58ed34ad88a2.svg";
export { ForwardRef as ReactComponent };